<template>
  <vue-slider v-bind="$attrs" ref="vueSlider" class="slider" :use-keyboard="true"><slot></slot></vue-slider>
</template>

<script>
// vue-slider has some issues with SSR. This seems to fix.
// https://github.com/NightCatSama/vue-slider-component/issues/114#issuecomment-508677648
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.common';
import 'vue-slider-component/dist-css/vue-slider-component.css';
import 'vue-slider-component/theme/default.css';

export default {
  name: 'fs-slider',
  components: { VueSlider },
  inheritAttrs: false,
};
</script>

<style scoped lang="scss">
@import '@styles/variables';

.slider {
  background: transparent;

  :deep(.vue-slider-rail) {
    height: 0.2rem;
    background: rgba($c-dark, 0.25);
  }

  // The dots are flattened to z-index 1 below, which leaves DOM order deciding
  // the stack — with two handles close together the upper one's value label
  // always covers the lower's. The grabbed or focused handle wins instead:
  // its value is the one being read.
  :deep(.vue-slider-dot.vue-slider-dot-focus) {
    z-index: 2;
  }

  :deep(.vue-slider-dot-tooltip-inner) {
    padding: 4px 5px;
    border-color: $c-dark;
    background-color: $c-dark;
    font-size: 1.2rem;
    opacity: 1;
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }
  }

  // Tooltip
  .diy-tooltip {
    margin-top: -0.7rem;
    font-size: 1.2rem;
  }

  // Line between dots
  :deep(.vue-slider-process) {
    background: transparent;

    &::before {
      content: '';
      width: 100%;
      height: 0.2rem;
      position: absolute;
      left: 0;
      background: rgba($c-dark, 1);
    }
  }

  // Dots
  :deep(.vue-slider-dot) {
    z-index: 1;
    .vue-slider-dot-handle {
      width: 1.6rem;
      height: 1.6rem;
      position: relative;
      background: transparent;
      box-shadow: none;

      &::before {
        content: '';
        width: 3rem;
        height: 3rem;
        position: absolute;
        top: -0.7rem;
        left: -0.7rem;
      }

      &::after {
        content: '';
        width: 1.2rem;
        height: 1.2rem;
        box-sizing: border-box;
        border: 0.2rem rgba($c-dark, 1) solid;
        border-radius: 10rem;
        position: absolute;
        top: 0.2rem;
        left: 0.2rem;
        background: #fff;
        box-shadow: 0 1px 0.2rem rgba(0, 0, 0, 0.25);
        transition:
          width 0.15s ease,
          height 0.15s ease,
          top 0.15s ease,
          left 0.15s ease;
      }
    }
  }

  :deep(.vue-slider-dot-handle:hover),
  :deep(.vue-slider-dot-dragging .vue-slider-dot-handle) {
    &::after {
      width: calc(1.2rem + 0.4rem);
      height: calc(1.2rem + 0.4rem);
      top: 0;
      left: 0;
    }
  }
}
</style>
